import validator from 'validator';

export const validateEmail = (value?: string | null) => {
  if (!value || !validator.isEmail(value)) {
    return 'Please enter a valid email address';
  }

  return undefined;
};
